import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./iggg-ui.css";
import "./ds-ui.css";
import App from "./App";
import { bootstrapTheme } from "./hooks/useTheme";
import { reloadOnceForStaleChunk } from "./ErrorBoundary";

// FOUC 방지 — 첫 paint 전에 dataset.theme 적용
bootstrapTheme();

// 배포 직후 '낡은 탭'의 옛 해시 청크 404(Vite 공식 이벤트) — 자동 새로고침 1회
window.addEventListener("vite:preloadError", (e) => {
  if (reloadOnceForStaleChunk()) e.preventDefault();
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
